import { useEffect, useState, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

export const Title = ({
  id,
  text,
  sub,
  anim,
  color,
}: {
  id: string
  text: string
  sub: string
  anim: string
  color?: string
}) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const themeContext = useContext(ThemeContext)

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('test', { detail: { data: container, id: id } })
    )
  }, [container, id])

  return (
    <TextWidth>
      <>
        <Container color={color} ref={setContainer}>
          <Number color={color}>{parseInt(id) + 1}</Number>
          <Text>{text}</Text>
          {sub && <Sub>{sub}</Sub>}
        </Container>
        {anim && (
          <Anim>
            <VideoContainer>
              <VideoContent>
            <video
              width={'100%'}
              height={'auto'}
              preload='auto'
              muted
              // poster=''
              playsInline
              autoPlay
              loop
              src={require(`../../animations/adults/${themeContext.colorMode}/${anim}.mp4`)}
            />
            </VideoContent>
            </VideoContainer>
          </Anim>
        )}
      </>
    </TextWidth>
  )
}

const Anim = styled.div`
  position: relative;
`

const Container = styled.div<{ color?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 1.85em;
  margin-bottom: 40px;
  margin-top: 40px;
  text-align: center;

  &:after {
    content: '';
    width: 60px;
    height: 2px;
    background-color: ${({ theme, color }) => color ? color: theme.tenantColor};
    margin-top: 1em;
  }
`

const Number = styled.div<{ color?: string }>`
  position: relative;
  width: 1.5em;
  background-color: ${({ theme, color }) => color ? color : theme.tenantColor};
  color: ${({ theme }) => theme.colorMode === 'dark' ? '#121212' : '#ffffff'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  font-weight: 800;
  font-family: var(--font-sans-serif);
  line-height: 0;
  padding-top: 0.75em;
  padding-bottom: 0.75em;
`

const Text = styled.div`
  font-family: var(--font-serif);
  color: ${({ theme }) => theme.textColor};
  line-height: 1.1;
`

const Sub = styled.div`
  font-family: var(--font-sans-serif);
  color: ${({ theme }) => theme.textColor};
  font-size: 0.65em;
  margin-top: 0.35em;
`

const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const VideoContent = styled.div`
width: 100%;
max-width: 300px;
`

export default Title
